import { createAction, props } from '@ngrx/store';
import { State } from './reducer';

export const setPageErrorData = createAction(
  '[Error] Redirect',
  props<State>(),
);
